import React, { useEffect } from "react";

const CommonDialog = ({ title, onCloseDialog, onCheck, sourceDialog }: any) => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div className="z-30 h-screen w-full fixed left-0 top-0 flex justify-center items-center bg-black bg-opacity-70">
      <div className="bg-white rounded shadow-lg w-10/12 md:w-1/3 text-gray-500">
        <div className="px-4 py-2 flex justify-end items-center">
          <span onClick={onCloseDialog}>
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </span>
        </div>
        <div className='px-4 py-6 text-center'>
          {title}
        </div>
        {!sourceDialog ? <div className="flex justify-between items-center py-4 px-8 gap-4">
          <button onClick={onCloseDialog} className="w-1/2 bg-gray-point py-2 rounded-md text-white">
            아니요
          </button>
          <button onClick={onCheck} className="w-1/2 bg-yellow-point py-2 rounded-md text-gray-600">
            네
          </button>
        </div> : <div></div>}
      </div>
    </div>
  );
};

export default CommonDialog;
